import type { EnumUnion } from '@dresscode-frontend/utility-types';
import { z } from 'zod';

import {
  StorageService,
  STORAGE_DRIVE_TYPE_VALUES,
} from '@/routes/_staff/storage-files/_list/-shared/-constants';

export const Columns = {
  NAME: 'NAME',
  PERMISSION_HOLDERS: 'PERMISSION_HOLDERS',
  PARENT_FOLDER: 'PARENT_FOLDER',
  OWNER: 'OWNER',
  LAST_MODIFIED_TIME: 'LAST_MODIFIED_TIME',
} as const;
export type Columns = EnumUnion<typeof Columns>;

export const SearchSchema = z.object({
  // jsurl2 は `?storageService=GOOGLE_DRIVE` 形式で `_` をスペースに変換する
  storageService: z
    .preprocess(
      (val) => (typeof val === 'string' ? val.replace(/ /g, '_') : val),
      z.nativeEnum(StorageService),
    )
    .optional()
    .default(StorageService.BOX),
  page: z.number().default(1),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  parentFolderId: z.string().optional(),
  mimeTypes: z.array(z.string()).optional(),
  driveType: z.enum(STORAGE_DRIVE_TYPE_VALUES).optional().default('SHARED'),
  driveIds: z.array(z.string()).optional(),
  orderBy: z
    .enum([
      'NAME',
      'CREATED_TIME',
      'LAST_MODIFIED_TIME',
      'PARENT_FOLDER',
      'OWNER',
    ])
    .optional(),
  orderDirection: z.enum(['asc', 'desc']).optional(),
});
export type SearchSchema = z.infer<typeof SearchSchema>;
